module.exports = __webpack_public_path__ + "static/media/baza_foto_1_A.34209082.png";